import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

export const useDeleteXeroLedgerAccountMapping = () => {
  const { displayNotification } = useNotifications()

  const deleteMappingMutator = useMutation(
    dashboardv99990101Client.deleteXeroLedgerAccountMapping
  )

  return async (id: string) => {
    await deleteMappingMutator.mutateAsync(
      { id },
      {
        onSuccess: () => {
          displayNotification('Xero ledger account mapping removed', {
            type: 'success'
          })
        },
        onError: () => {
          displayNotification('Failed to remove Xero ledger account mapping', {
            type: 'error'
          })
        }
      }
    )
  }
}
